import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const MODES = {
  all: { label: "Tous les jours", weekdays: [0, 1, 2, 3, 4, 5, 6] },
  week: { label: "Semaine (lun-jeu)", weekdays: [0, 1, 2, 3] },
  weekend: { label: "Week-end (ven-dim)", weekdays: [4, 5, 6] },
};

export default function RangeTool({ slug, onDone }) {
  const y = new Date().getFullYear();
  const [f, setF] = useState({ start: `${y}-07-01`, end: `${y}-08-31`, price: "", mode: "all" });

  const run = async (extra) => {
    try {
      const { data } = await api.put("/admin/prices/range", {
        gite_slug: slug, start: f.start, end: f.end,
        weekdays: MODES[f.mode].weekdays,
        price: extra.reset ? null : Number(f.price),
        closed: !!extra.closed, reset: !!extra.reset,
      });
      toast.success(`${data.updated} jour(s) mis à jour`);
      onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="mt-5 border border-white/10 bg-panel p-5" data-testid="range-tool">
      <h3 className="font-display text-xl text-bone">Tarifs par période</h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Appliquez un tarif à une plage entière (vacances scolaires, saison) en ciblant la semaine ou le week-end.
      </p>
      <div className="mt-4 flex flex-wrap items-end gap-4">
        <label className="text-sm">
          <span className="mb-1.5 block text-xs text-bone">Du</span>
          <input type="date" className="field !py-2" data-testid="range-start" value={f.start}
            onChange={(e) => setF({ ...f, start: e.target.value })} />
        </label>
        <label className="text-sm">
          <span className="mb-1.5 block text-xs text-bone">Au</span>
          <input type="date" className="field !py-2" data-testid="range-end" value={f.end}
            onChange={(e) => setF({ ...f, end: e.target.value })} />
        </label>
        <label className="text-sm">
          <span className="mb-1.5 block text-xs text-bone">Jours visés</span>
          <select className="field !py-2" data-testid="range-mode" value={f.mode}
            onChange={(e) => setF({ ...f, mode: e.target.value })}>
            {Object.entries(MODES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
        </label>
        <label className="text-sm">
          <span className="mb-1.5 block text-xs text-bone">Prix (€)</span>
          <input type="number" className="field !py-2 w-32" data-testid="range-price" value={f.price}
            onChange={(e) => setF({ ...f, price: e.target.value })} placeholder="ex : 185" />
        </label>
        <button className="btn-primary !py-2.5" data-testid="range-apply" disabled={!f.price} onClick={() => run({})}>
          Appliquer
        </button>
        <button className="btn-ghost !py-2.5" data-testid="range-close" onClick={() => run({ closed: true })}>Bloquer</button>
        <button className="btn-ghost !py-2.5" data-testid="range-reset" onClick={() => run({ reset: true })}>Réinitialiser</button>
      </div>
    </div>
  );
}
